var _title, _desc, _defs, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSubOrder = function SvgSubOrder(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u7F16\u7EC4 69")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88B8FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1673FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE5\\u4F5C\\u53F0/\\u89D2\\u8272\\u7BA1\\u7406/\\u5B50\\u8D26\\u53F7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E3B\\u8D26\\u53F7-\\u5DE5\\u4F5C\\u53F001",
    transform: "translate(-1096.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-72",
    transform: "translate(1096.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5 L20,5 L20,17.5 C20,18.8807119 18.8807119,20 17.5,20 L2.5,20 C1.11928813,20 1.69088438e-16,18.8807119 0,17.5 L0,5 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 5,
    y: 11,
    width: 10,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L20,0 L18.190983,3.61803399 C17.767503,4.46499406 16.9018452,5 15.954915,5 L4.04508497,5 C3.09815483,5 2.23249703,4.46499406 1.80901699,3.61803399 L0,0 Z",
    id: "\\u77E9\\u5F62\\u590D\\u5236-5",
    fill: "#84B5FF",
    transform: "translate(10.000000, 2.500000) scale(1, -1) translate(-10.000000, -2.500000) "
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subOrder.cae3ff26.svg";
export { ForwardRef as ReactComponent };